import React from 'react'

// @src imports
import { useQueries, useState } from 'src/hooks'
import { Pagination, RwdHeader, RwdTable } from 'src/chrome'

import { getPaginatedInvites } from 'src/graphql'

import styles from './invites.module.scss'
import { Text } from '@sendoutcards/quantum-design-ui'
import Prospect from './Prospect'

const PAGE_SIZE = 20

const Invites: React.FC = () => {
  const [page, setPage] = useState(1)
  const [{ results: invites, count }] = useQueries(
    getPaginatedInvites({ page }),
  )

  return (
    <div className={styles.outerContainer}>
      <div className={styles.container}>
        <section className={`${styles.column} ${styles.order2}`}>
          <RwdTable>
            <RwdHeader>
              <th>
                <Text type="body" color="primaryBrand">
                  Name
                </Text>
              </th>
              <th>
                <Text type="body" color="primaryBrand">
                  Date
                </Text>
              </th>
              <th>
                <Text type="body" color="primaryBrand">
                  Phone
                </Text>
              </th>
              <th>
                <Text type="body" color="primaryBrand">
                  Email
                </Text>
              </th>
              <th>
                <Text type="body" color="primaryBrand">
                  Address
                </Text>
              </th>
              <th>
                <Text type="body" color="primaryBrand">
                  Activity
                </Text>
              </th>
              <th>
                <Text type="body" color="primaryBrand">
                  Stream
                </Text>
              </th>
              <th />
            </RwdHeader>
            <tbody>
              {invites.map((invite, index) => {
                return <Prospect key={index} index={index} invite={invite} />
              })}
            </tbody>
          </RwdTable>
        </section>
      </div>
      <div>
        <Pagination
          onPageChange={setPage}
          count={count}
          pagesToShow={5}
          pageSize={PAGE_SIZE}
          currentPage={page}
        />
      </div>
    </div>
  )
}

export default Invites
